import { render, staticRenderFns } from "./CACG1120.vue?vue&type=template&id=aab693aa"
import script from "./CACG1120Controller.ts?vue&type=script&lang=ts&external"
export * from "./CACG1120Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports